import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import styles from './style.module.less';

const ProviderRegistrationError = ({ className = '', dismissRegistrationError }) => (
  <div className={classnames(styles.wrapper, className)}>
    <div className={styles.icon}>
      <FontAwesomeIcon icon={faExclamationCircle} />
      <FormattedMessage defaultMessage='Error' description='text: Error' id='y1ngu8' />
    </div>
    <FormattedMessage
      defaultMessage='The Carrier Service you requested was unable to connect. Consider adding again and making sure your carrier account information is added correctly.'
      description='Error message when failure to connect to a provider'
      id='0j+5dV'
    />
    <div className={styles.close} onClick={dismissRegistrationError}>
      <FontAwesomeIcon icon={faXmark} />
    </div>
  </div>
);

ProviderRegistrationError.propTypes = {
  className: PropTypes.string,
  dismissRegistrationError: PropTypes.func.isRequired,
};

export default ProviderRegistrationError;
